module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/m5dl9m/tc-custom/9783987441943.jpg?1704424377260",
      "alt": "This image is the cover for the book Think Yourself to Death and two more stories, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Think Yourself to Death and two more stories, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Three Classic Short Stories from The Golden Age of Science Fiction. Featured here: \"Think Yourself to Death\", \"Es Percipi\", and \"Newshound\" all by Stephen Marlowe.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Marlowe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephen Marlowe (born Milton Lesser, August 7, 1928 in Brooklyn, New York, died February 22, 2008 (aged 79), in Williamsburg, Virginia) was an American author of science fiction, mystery novels, and fictional autobiographies of Goya, Christopher Columbus, Miguel de Cervantes, and Edgar Allan Poe. He is best known for his detective character Chester Drum, whom he created for the 1955 novel The Second Longest Night. Lesser also wrote using the pseudonyms Adam Chase, Andrew Frazer, C.H. Thames, Jason Ridgway, Stephen Wilder and Ellery Queen.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0